<template>
  <Slide>
    <MDCSlot />
  </Slide>
</template>

<script lang="ts" setup>
import { Slide } from '@crearis/ui'
</script>
